import axios from '../../../axios';
import { getFullTextSearchString } from '../../InvoicingClientService';
import ClosureDTO from '../types/ClosureDTO';
import ClosureFileDTO from '../types/ClosureFileDTO';
import { ClosureFiltersDTO } from '../types/ClosureFiltersDTO';
import PlacementOriginDTO from '../types/PlacementOriginDTO';
import PlacementStatusDTO from '../types/PlacementStatusDTO';

const url = '/invoicingservice/api/closures';

export const getClosureList = (pageNo: number, pageSize: number) =>
  axios.get(`${url}/list?page=${pageNo}&size=${pageSize}`);

export const createClosure = (closureDTO: ClosureDTO) => axios.post(`${url}/create`, closureDTO);

export const updateClosure = (closureDTO: ClosureDTO) => axios.put(`${url}/update`, closureDTO);

export const getClosureById = (id: string) => axios.get(`${url}/${id}`);

export const getClosureByCandidateName = (
  clientId: string,
  ourEntityId: string,
  searchTerm: string
) =>
  axios.get(
    `${url}/candidate-name?clientId=${clientId}&ourEntityId=${ourEntityId}&searchTerm=${encodeURIComponent(
      getFullTextSearchString(searchTerm)
    )}`
  );

export const getAllClosuresByInvoiceId = (invoiceId: string) =>
  axios.get(`${url}?invoiceId=${invoiceId}`);

export const getClosures = (closureFiltersDTO: ClosureFiltersDTO) =>
  axios.post(`${url}/list`, closureFiltersDTO);

export const getClosureDetailsById = (id: string) => axios.get<ClosureDTO>(`${url}/getbyid/${id}`);

export const createClosureFile = (ClosureFileDTO: ClosureFileDTO) =>
  axios.post(`${url}/closure-file/save-file`, ClosureFileDTO);

export const getClosureFileList = (id: string) =>
  axios.get(`${url}/closure-file/by-closure-id/${id}`);

export const getClosureByCandidiateId = (id: string) => axios.get(`${url}/candidiate-list/${id}`);

export const getPlacementStatusList = () => axios.get(`${url}/getAllPlacementStatus`);

export const savePlacementStatus = (placementStatus: PlacementStatusDTO) =>
  axios.post(`${url}/create-placementStatus`, placementStatus);

export const updatePlacementStatus = (id: string, closureDTO: ClosureDTO) =>
  axios.put(`${url}/update-closureStatus/${id}`, closureDTO);

export const getClosuresBySubmissionIds = (ids: string[]) => axios.post(`${url}/submissions/`, ids);

export const getPlacementOriginList = () => axios.get(`${url}/getplacementorigins`);

export const savePlacementOrigin = (placementOrigin: PlacementOriginDTO) =>
  axios.post(`${url}/createplacementorigin`, placementOrigin);

export const updatePlacementOrigin = (id: string, placementOrigin: PlacementOriginDTO) =>
  axios.put(`${url}/updateplacementorigin/${id}`, placementOrigin);

export const getAllByIds = (ids: string[]) => axios.post(`${url}/ids/`, ids);
